export default {"src":"/_next/static/media/menu.90190800.svg","height":39,"width":39,"blurWidth":0,"blurHeight":0};